import { useEffect } from "react";
import { company } from "@/data/site";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const Seo = ({ title, description, schema }) => {
  useEffect(() => {
    const full = `${title} | ${company.name}`;
    document.title = full;
    setMeta("name", "description", description);
    setMeta("property", "og:title", full);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", window.location.href);
    let ld = document.getElementById("ld-page");
    if (schema) {
      if (!ld) {
        ld = document.createElement("script");
        ld.type = "application/ld+json";
        ld.id = "ld-page";
        document.head.appendChild(ld);
      }
      ld.textContent = JSON.stringify(schema);
    } else if (ld) ld.remove();
  }, [title, description, schema]);
  return null;
};

export const businessSchema = {
  "@context": "https://schema.org",
  "@type": "AutoRepair",
  name: company.name,
  slogan: company.slogan,
  telephone: company.phone,
  ...(company.confirmed.email ? { email: company.email } : {}),
  ...(company.confirmed.address
    ? { address: { "@type": "PostalAddress", streetAddress: company.street, postalCode: company.zip, addressLocality: company.city, addressCountry: "CH" } }
    : {}),
  founder: { "@type": "Person", name: company.owner },
  areaServed: company.city,
  priceRange: "CHF",
};

export const faqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
});
